import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';

import { config } from './config';

// Initialize Firebase
const app = initializeApp(config);
const analytics = getAnalytics(app);
const functions = getFunctions(app);

export { app, analytics, functions };
